import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { 
  FileTextIcon, 
  CalendarIcon, 
  UploadCloudIcon 
} from "lucide-react";

export default function ClientPortalPreview() {
  return (
    <section className="py-12 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:text-center mb-12">
          <h2 className="text-base text-primary-600 font-semibold tracking-wide uppercase">Client Portal</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-slate-900 sm:text-4xl">
            Track your progress
          </p>
          <p className="mt-4 max-w-2xl text-xl text-slate-500 lg:mx-auto">
            Our secure client portal helps you manage your journey to stability and success.
          </p>
        </div>

        <div className="relative">
          <div className="relative lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
            <div className="relative">
              <h3 className="text-2xl font-extrabold text-slate-900 tracking-tight sm:text-3xl">
                Everything you need in one place
              </h3>
              <p className="mt-3 text-lg text-slate-500">
                Our portal provides a personalized dashboard to track your progress, connect with your case worker, and access resources.
              </p>

              <dl className="mt-10 space-y-10">
                <div className="relative">
                  <dt>
                    <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                      <FileTextIcon className="h-6 w-6" />
                    </div>
                    <p className="ml-16 text-lg leading-6 font-medium text-slate-900">Progress Tracking</p>
                  </dt>
                  <dd className="mt-2 ml-16 text-base text-slate-500">
                    Monitor your journey through clear milestones and achievements, from resume completion to job placement.
                  </dd>
                </div>

                <div className="relative">
                  <dt>
                    <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                      <CalendarIcon className="h-6 w-6" />
                    </div>
                    <p className="ml-16 text-lg leading-6 font-medium text-slate-900">Appointment Scheduling</p>
                  </dt>
                  <dd className="mt-2 ml-16 text-base text-slate-500">
                    Book meetings with your case worker and keep track of upcoming interviews or training sessions.
                  </dd>
                </div>

                <div className="relative">
                  <dt>
                    <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500 text-white">
                      <UploadCloudIcon className="h-6 w-6" />
                    </div>
                    <p className="ml-16 text-lg leading-6 font-medium text-slate-900">Document Management</p>
                  </dt>
                  <dd className="mt-2 ml-16 text-base text-slate-500">
                    Safely store and share important documents like your resume, certifications, and identification.
                  </dd>
                </div>
              </dl>
            </div>

            <div className="mt-10 -mx-4 relative lg:mt-0">
              <div className="relative rounded-lg shadow-lg overflow-hidden">
                <img 
                  className="relative rounded-lg shadow-lg object-cover object-left" 
                  src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-1.2.1&auto=format&fit=crop&w=2850&q=80" 
                  alt="Client portal dashboard mockup" 
                />
              </div>
            </div>
          </div>

          <div className="mt-12 text-center">
            <Link href="/auth">
              <Button>Access Client Portal</Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
